import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "reactstrap";

import { InputField } from "@/components/Common/Inputs";
import QuillEditor from "@/components/Common/Inputs/QuillEditor";
import FileUpload from "@/components/Common/FileUpload";
import ModernModal from "@/components/Common/Modals/ModernModal";
import Section from "@/components/Common/Section";
import { useNotificationModal } from "@/context/notificationContext";

import { useSendEmailOrderRequestsMutation } from "@/api/Endpoints/Globo/Transactions/OrderRequest/OrderRequests";

const MODULE_NAME = "Order / Availment";
const CC_EMAIL_ADDRESS = process.env.REACT_APP_COORDINATOR_GROUP_EMAIL || "";

const SendEmailModal = ({ data, show, onCloseClick }) => {
  const { notification, hideModal } = useNotificationModal();
  const [files, setFiles] = useState([]);
  const [sendEmail, { isLoading: isSending }] = useSendEmailOrderRequestsMutation();

  const defaultValues = {
    emailAddress: data?.patientEmailAddress || "",
    ccEmailAddress: CC_EMAIL_ADDRESS,
    subject: "",
    message: "",
  };

  const { handleSubmit, reset, control } = useForm({ defaultValues });

  useEffect(() => {
    if (show) {
      reset({
        emailAddress: data?.patientEmailAddress || "",
        ccEmailAddress: CC_EMAIL_ADDRESS,
        subject: "",
        message: "",
      });
      setFiles([]);
    }
  }, [show]);

  const onSubmit = async (formData) => {
    const payload = {
      orderRequestId: data?.orderRequestId,
      emailAddress: formData.emailAddress,
      ccEmailAddress: formData.ccEmailAddress,
      subject: formData.subject,
      message: formData.message,
      files,
    };

    try {
      const res = await sendEmail(payload).unwrap();

      if (res?.success) {
        notification({
          type: "success",
          title: MODULE_NAME,
          message: "Your email has been successfully sent.",
        });
        setTimeout(() => {
          hideModal();
          onCloseClick();
        }, 2000);
      } else {
        notification({
          type: "error",
          title: MODULE_NAME,
          message: "Failed to send email. Please try again.",
        });
      }
    } catch (error) {
      notification({
        type: "error",
        title: MODULE_NAME,
        message: "Failed to send email. Please try again.",
      });
    }
  };

  return (
    <ModernModal
      isProcess
      title="Send Email"
      isOpen={show}
      width="980px"
      isSaving={isSending}
      canSave={true}
      saveLabel="Send"
      savingLabel="Sending..."
      saveIcon="ri-mail-send-line"
      onSave={handleSubmit(onSubmit)}
      onClose={onCloseClick}
    >
      <Section title="Recipient">
        <Row>
          <Col lg={6}>
            <InputField name="emailAddress" control={control} label="To" disabled />
          </Col>
          <Col lg={6}>
            <InputField name="ccEmailAddress" control={control} label="CC" disabled />
          </Col>
        </Row>
      </Section>

      <Section title="Message">
        <Row>
          <Col lg={12}>
            <InputField
              name="subject"
              control={control}
              label="Subject"
              placeholder="Enter email subject..."
              maxLength={200}
              rules={{ required: "Subject is required." }}
            />
          </Col>
          <Col lg={12}>
            <QuillEditor
              name="message"
              control={control}
              label="Body"
              placeholder="Compose your message..."
              height={220}
              rules={{ required: "Message is required." }}
            />
          </Col>
        </Row>
      </Section>

      <Section title="Attachments">
        <FileUpload onFilesChange={setFiles} />
      </Section>
    </ModernModal>
  );
};

export default SendEmailModal;
